var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCompany = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 37,
  fill: "none",
  viewBox: "0 0 36 37"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M23.5 10.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-1 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m9 21C31.5 24.343 25.586 19 18 19S4.5 24.343 4.5 31.5a.5.5 0 0 0 .5.5h26a.5.5 0 0 0 .5-.5M5.51 31C5.78 24.672 11.126 20 18 20s12.221 4.672 12.49 11z",
  clipRule: "evenodd"
})));
export default SvgCompany;